import { Badge } from "./Badge";
import type { BadgeTone } from "./Badge";
import { OUTSOURCE_STATUS_LABEL } from "../api/types";
import type { OutsourceStatus } from "../api/types";

// 發包狀態 tag。業主要在報價分類旁邊一眼看出這一類發包了沒有。
// 三種狀態一律「顏色 + 文字」,不可只靠顏色 —— 色盲與黑白列印都要讀得出來。

const TONES: Record<OutsourceStatus, BadgeTone> = {
  NOT_ORDERED: "neutral",
  ORDERED: "ok",
  PENDING: "warn",
};

export interface OutsourceTagProps {
  /** 沒有值(舊資料)一律當成未發包,不留空白。 */
  status?: OutsourceStatus | null;
  className?: string;
}

export function OutsourceTag({ status, className = "" }: OutsourceTagProps) {
  const value: OutsourceStatus = status ?? "NOT_ORDERED";
  return (
    <Badge tone={TONES[value]} className={className}>
      {OUTSOURCE_STATUS_LABEL[value]}
    </Badge>
  );
}
